"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBooksInteriorPrintable;
const createPrintable_1 = __importDefault(require("./createPrintable"));
const either_1 = require("../../types/either");
const designs_1 = require("../designs");
const constants_1 = require("../../services/designs/constants");
const EditableTextLayer_1 = require("../../models/layers/EditableTextLayer");
const _1 = require("./");
// We should pass in the index/page number of the printable to generate the correct design
function createBooksInteriorPrintable(_ref) {
  let {
    sku,
    userId,
    projectId,
    creationDate,
    template,
    interiorPrintableIdx,
    printableId,
    designFilters
  } = _ref;
  const getBookInteriorDesignResult1 = (0, designs_1.getBookInteriorDesign)(template.designs, interiorPrintableIdx, new Date(creationDate).getTime(), designFilters);
  if (getBookInteriorDesignResult1.isLeft()) {
    return (0, either_1.left)(getBookInteriorDesignResult1.value);
  }
  let designId = getBookInteriorDesignResult1.value.id;
  let getBookInteriorDesignResult2;
  const isCompositeDesign = getBookInteriorDesignResult1.value.coverage === 'partial';
  if (isCompositeDesign) {
    getBookInteriorDesignResult2 = (0, designs_1.getBookInteriorDesign)(template.designs, interiorPrintableIdx, new Date(creationDate).getTime() + 1, [...(designFilters || []), constants_1.PARTIAL_FILTER]);
    if (getBookInteriorDesignResult2.isLeft()) {
      return (0, either_1.left)(getBookInteriorDesignResult2.value);
    }
    designId = `${getBookInteriorDesignResult1.value.id}|${getBookInteriorDesignResult2.value.id}`;
  }
  const layersResult = (0, designs_1.getLayersForDesign)(sku, template, getBookInteriorDesignResult1.value, getBookInteriorDesignResult2 === null || getBookInteriorDesignResult2 === void 0 ? void 0 : getBookInteriorDesignResult2.value);
  if (layersResult.isLeft()) {
    return (0, either_1.left)(layersResult.value);
  }
  const layers = Array.isArray(layersResult.value) ? layersResult.value : [];
  layers.map(layer => {
    // In case defaultData.content exists, we need to create userData with that information. That's why we call this function
    if ((0, EditableTextLayer_1.isEditableTextLayer)(layer) && layer.defaultData.content && layer.defaultData.content !== '') {
      (0, _1.createDefaultLayers)(layer, template.surface);
    }
  });
  return (0, createPrintable_1.default)(sku, userId, projectId, designId, layersResult.value, template, printableId, creationDate);
}